import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router';

import BasePage from "../components/base/BasePage";


const User = () => import('../views/user/User');
const UserList = () => import('../views/user/UserList');
const Video = () => import('../views/video/Video');
const VideoList = () => import('../views/video/VideoList');

const Score= () => import('../views/score/Score');
const ScoreList = () => import('../views/score/ScoreList');
const Advise= () => import('../views/advise/advise');
const AdviseList= () => import('../views/advise/AdviseList');

const Record= () => import('../views/record/Record');
const RecordList = () => import('../views/record/RecordList');

const Share= () => import('../views/share/Share');
const ShareList = () => import('../views/share/ShareList');

const Config= () => import('../views/config/Config');
const ConfigList = () => import('../views/config/ConfigList');

const CookieConfig= () => import('../views/cookie/CookieConfig');
const CookieConfigList = () => import('../views/cookie/CookieConfigList');

const Member= () => import('../views/member/Member');
const MemberList = () => import('../views/member/MemberList');

const Order= () => import('../views/order/Order');
const OrderList = () => import('../views/order/OrderList');

import Login from "../views/login/Login.vue";
import Register from "../views/register/Register.vue";
import Forget from "../views/forget/Forget.vue";
const Pay = () => import('../views/pay/Pay');
const Sign = () => import('../views/sign/Sign');
const PersonalCenter = () => import('../views/person/PersonalCenter');

const Statistics = () => import('../views/statistics/Statistics');
const StatisticsList = () => import('../views/statistics/StatisticsList');


const routes = [
    {
        path: '/',
        redirect: '/login'
    },


    {
        path: '/login',
        name: 'Login',
        component: Login
    },

    {
        path: '/register',
        name: 'Register',
        component: Register
    },

    {
        path: '/forget',
        name: 'Forget',
        component: Forget
    },
    {
        path: '/pay',
        name: 'Pay',
        component: Pay
    },

    {
        path: '/person',
        name: 'PersonalCenter',
        component: PersonalCenter
    },

    {
        path: '/sign',
        name: 'Sign',
        component: Sign
    },

    {
        path: '/advise',
        name: 'Advise',
        component: Advise
    },


    {
        path: '/pages',
        component: BasePage,
        children: [

            {
                path: "config",
                name: 'Config',
                component: Config,
                children: [
                    {
                        path: "configList",
                        name: "ConfigList",
                        component: ConfigList,
                    },
                ]
            },

            {
                path: "cookieConfig",
                name: 'CookieConfig',
                component: CookieConfig,
                children: [
                    {
                        path: "cookieConfigList",
                        name: "CookieConfigList",
                        component: CookieConfigList,
                    },
                ]
            },

            {
                path: "advise",
                name: 'Advise',
                component: Advise,
                children: [
                    {
                        path: "adviseList",
                        name: "AdviseList",
                        component: AdviseList,
                    },
                ]
            },

            {
                path: "video",
                name: 'Video',
                component: Video,
                children: [
                    {
                        path: "videoList",
                        name: "VideoList",
                        component: VideoList,
                    },
                ]
            },


            {
                path: "share",
                name: 'Share',
                component: Share,
                children: [
                    {
                        path: "shareList",
                        name: "ShareList",
                        component: ShareList,
                    },
                ]
            },

            {
                path: "order",
                name: 'Order',
                component: Order,
                children: [
                    {
                        path: "orderList",
                        name: "OrderList",
                        component: OrderList,
                    },
                ]
            },
            {
                path: "member",
                name: 'Member',
                component: Member,
                children: [
                    {
                        path: "memberList",
                        name: "MemberList",
                        component: MemberList,
                    },
                ]
            },

            {
                path: "record",
                name: 'Record',
                component: Record,
                children: [
                    {
                        path: "recordList",
                        name: "RecordList",
                        component: RecordList,
                    },
                ]
            },

            {
                path: "user",
                name: 'User',
                component: User,
                children: [
                    {
                        path: "userList",
                        name: "UserList",
                        component: UserList,
                    },
                    // {
                    //     path: "personalCenter",
                    //     name: "PersonalCenter",
                    //     component: PersonalCenter,
                    // },
                ]
            },

            {
                path: "score",
                name: 'Score',
                component: Score,
                children: [
                    {
                        path: "scoreList",
                        name: "ScoreList",
                        component: ScoreList,
                    },
                ]
            },
            {
                path: "statistics",
                name: 'Statistics',
                component: Statistics,
                children: [
                    {
                        path: "statisticsList",
                        name: "StatisticsList",
                        component: StatisticsList,
                    },
                ]
            },

        ]
    },

];


const router = new createRouter({
    // history: createWebHistory(),
    history: createWebHashHistory (),
    mode: 'hash',
    routes
});

export default router;
